import { render, staticRenderFns } from "./LaboratorySingle.vue?vue&type=template&id=0a873f71"
import script from "./LaboratorySingle.vue?vue&type=script&lang=js"
export * from "./LaboratorySingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports